import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import ReactTimeAgo from 'react-time-ago';
import Loader from 'react-loader-spinner';

import {showAlertMessage} from "../../modules/alert";


class NoticeActionSheet extends React.Component {
    constructor(props) {
        super(props);
        firebase.firestore().settings({timestampsInSnapshots: true});
        this.noticeRef = firebase.firestore().collection('notice');
    }

    state = {
        openSideMenu: false,
        noticeList: {isLoading: true, list: []},
    };


    componentDidMount() {
        const noticeQuery = this.noticeRef.orderBy("date", "desc");
        noticeQuery.get().then((snapshot) => {
            let qd = [];
            snapshot.forEach((doc) => {
                if (doc.exists) {
                    let d = doc.data();
                    d['DOC_ID'] = doc.id;
                    qd.push(d);
                }
            });

            this.setState({noticeList: {...this.state.noticeList, isLoading: false, list: qd}});
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    showSideMenu = (show) => {
        this.setState({openSideMenu: show});
    };


    render() {
        const NL = this.state.noticeList.list;

        return (
            <div>
                <ActionSheet className="interesting-place-action-sheet" isOpen={true} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true}>
                    <div className="action-sheet-title action-sheet-title--material">
                        공지 사항
                    </div>
                    <ul className="list list--material">
                        {
                            !this.state.noticeList.isLoading ?
                                NL.map((e, i) => {
                                    return (
                                        <li key={['notice', 'list', i].join('_')} className="list-item list-item--material" onClick={() => this.props.showAlertMessage(e.detail, e.title)}>
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title" style={{fontSize: '12px'}}>{e.title}</div>
                                                <div className="list-item__subtitle"/>
                                            </div>
                                            <div className="list-item__right list-item--material__right">
                                                <small><ReactTimeAgo locale="ko">{e.date}</ReactTimeAgo></small>
                                            </div>
                                        </li>
                                    )
                                })
                                :
                                <li className="list-item list-item--material">
                                    <div className="list-item__title list-item--material__title text-center">
                                        <Loader type="ThreeDots" color="#00BFFF" height={40} width={40}/>
                                    </div>
                                </li>
                        }
                    </ul>
                    <ActionSheetButton className="action-sheet-close" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>공지 사항 닫기</ActionSheetButton>
                </ActionSheet>
            </div>
        )
    }
}

const mapStateToProps = ({user}) => ({
    userInfo: user.userInfo,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(NoticeActionSheet))